'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vueMixin = require('./vueMixin');

var _vueMixin2 = _interopRequireDefault(_vueMixin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {

    mixins: [_vueMixin2.default],

    props: ['editable'],

    data: function data() {
        return {
            localRecord: null
        };
    },

    computed: {
        record: function record() {
            if (this.localRecord) {
                return this.localRecord;
            } else {
                return this.unchangedRecord;
            }
        },
        hasChanges: function hasChanges() {
            return this.localRecord !== null;
        }
    },

    methods: {
        reset: function reset() {
            this.localRecord = JSON.parse(JSON.stringify(this.record));
        },
        save: function save() {
            var _this = this;

            if (this.exists) {
                var params = Object.assign({}, this.urlParams, { data: this.localRecord, record: this.unchangedRecord });
                return this.$store.dispatch(this.type + '/update', params).then(function () {
                    _this.localRecord = null;
                }).catch(this.handleErrors);
            } else {
                var _params = Object.assign({}, this.urlParams, { data: this.record });
                return this.$store.dispatch(this.type + '/store', _params).then(function () {
                    _this.localRecord = null;
                }).catch(this.handleErrors);
            }
        }
    }
};